/**
 * The parts of MLP's mark in its 200-unit square, as `assets/brand/mlp-mark.svg`
 * draws them, so the loaders animate exactly the mark.
 */

export interface Shape {
  d: string;
  fill: string;
  transform?: string;
}

const LEAF = 'M0 -13 C8 -6 8 6 0 13 C-8 6 -8 -6 0 -13 Z';
const leaf = (fill: string, transform: string): Shape => ({ d: LEAF, fill, transform });

/** The crown, its outer arc from left to right and then its inner arc. */
export const CROWN: Shape[] = [
  leaf('#3b6b4a', 'translate(37.0 84.9) rotate(-80) scale(1.00)'),
  leaf('#2f6d82', 'translate(44.6 64.0) rotate(-60) scale(1.00)'),
  leaf('#3f8f5f', 'translate(58.9 47.0) rotate(-40) scale(1.00)'),
  leaf('#4DB6AC', 'translate(78.1 35.9) rotate(-20) scale(1.00)'),
  leaf('#3b6b4a', 'translate(100.0 32.0) rotate(0) scale(1.00)'),
  leaf('#2f6d82', 'translate(121.9 35.9) rotate(20) scale(1.00)'),
  leaf('#3f8f5f', 'translate(141.1 47.0) rotate(40) scale(1.00)'),
  leaf('#4DB6AC', 'translate(155.4 64.0) rotate(60) scale(1.00)'),
  leaf('#3b6b4a', 'translate(163.0 84.9) rotate(80) scale(1.00)'),
  leaf('#3f8f5f', 'translate(66.2 76.5) rotate(-60) scale(0.7)'),
  leaf('#4DB6AC', 'translate(80.5 62.2) rotate(-30) scale(0.7)'),
  leaf('#3b6b4a', 'translate(100.0 57.0) rotate(0) scale(0.7)'),
  leaf('#2f6d82', 'translate(119.5 62.2) rotate(30) scale(0.7)'),
  leaf('#3f8f5f', 'translate(133.8 76.5) rotate(60) scale(0.7)'),
];

export const BODY: Shape = {
  d: 'M64 86 C82 110 92 118 100 120 C108 118 118 110 136 86 C128 116 114 132 107 156 L100 178 L93 156 C86 132 72 116 64 86 Z',
  fill: '#2f6d82',
};

const OUTER_LEAF = 'M98 188 C70 192 38 172 36 122 C54 160 76 176 96 182 Z';
const INNER_LEAF = 'M94 178 C74 174 62 156 64 126 C72 148 82 160 92 170 Z';

/** The lower leaves, outer then inner. The right pair is drawn as the left pair mirrored. */
export const LOWER_LEFT: Shape[] = [
  { d: OUTER_LEAF, fill: '#3b6b4a' },
  { d: INNER_LEAF, fill: '#4DB6AC' },
];
export const LOWER_RIGHT: Shape[] = [
  { d: OUTER_LEAF, fill: '#3f8f5f' },
  { d: INNER_LEAF, fill: '#4DB6AC' },
];
export const MIRROR = 'translate(200 0) scale(-1 1)';

export const SUN = { cx: 100, cy: 90, r: 19, fill: '#e0a341' };
